import 'react-app-polyfill/ie11';
import React, { useState, useEffect } from 'react';
import ReactDOM from 'react-dom';
import Root from './client_customizations/containers/Root/Root';
import { BrowserRouter as Router } from 'react-router-dom';
import { IntlProvider } from 'react-intl';
import * as serviceWorker from './serviceWorker';
import './utils/polyfills';
import messages_en from './client_customizations/translations/en.js';
import messages_esp from './client_customizations/translations/esp.js';
import createCache from '@emotion/cache';
import { CacheProvider } from '@emotion/react';

const App = () => {
  const [language, setLanguage] = useState('EN');
  const [messages] = useState({
    EN: messages_en,
    ES: messages_esp,
  });

  const changeLanguage = (language) => {
    localStorage.setItem('language', language);
    setLanguage(language);
  };
  const rootElement = document.getElementById('root');
  const emotionRoot = document.createElement('style');
  rootElement.appendChild(emotionRoot);

  const cache = createCache({
    key: 'css',
    prepend: true,
    container: emotionRoot, // change this to your root
    nonce: 'm7yvr64n3ob2ci9xdpl',
  });

  useEffect(() => {
    let key = localStorage.getItem('language');

    if (key) {
      setLanguage(key);
    }
  }, []);

  return (
    <IntlProvider locale={language} messages={messages[language]}>
      <Router>
        <CacheProvider value={cache}>
          <Root language={language} changeLanguage={changeLanguage} />
        </CacheProvider>
      </Router>
    </IntlProvider>
  );
};

const rootElement = document.getElementById('root');
ReactDOM.render(<App />, rootElement);

// ReactDOM.render(
//   <IntlProvider locale={language} messages={messages[language]}>
//     <Router>
//         <Root changeLanguage={changeLanguage}/>
//     </Router>
//   </IntlProvider>,
//   document.getElementById("root")
// );

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
